import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import Web3EthContract from "web3-eth-contract";
var async = require('async');

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 10px;
  border: 2px solid palevioletred;
  background-color: #F1FD97;
  padding: 20px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 300px;
  height: 80px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 24px;
  border-radius: 100%;
  border: 2px solid palevioletred;
  background-color: white;
  padding: 24px;
  font-weight: bold;
  font-size: 25px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: ;
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: grey;
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);

  const [claimingNft, setClaimingNft] = useState(false);
  const [saleClosed, setSaleClosed] = useState(false);

  const [feedback, setFeedback] = useState( <font color="black" size="+2">Amount to mint:</font>);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const presaleMintBtnClick = async () => {
setSaleClosed(false)
console.log(data.presaleStarted)

if(data.presaleStarted == true){

const balUser = await blockchain.smartContract.methods.balanceOf(blockchain.account).call();
var leftToMint = 7 - balUser;
var tooMany = "You can mint " + leftToMint + " more Cloodles in Presale, but don't worry, Public Sale is coming up!" ;
console.log("kay:", balUser)
console.log(CONFIG.MAX_PRESALE - balUser)
        if (mintAmount && mintAmount > 0 && mintAmount <= 7 && mintAmount <= (CONFIG.MAX_PRESALE - balUser)) {
           	setFeedback("")

            claimNFTsPresale();
        } else {
            setFeedback(tooMany)
        	console.log(balUser)

    }
}
else if(data.publicSaleStarted == true){
const balUser = await blockchain.smartContract.methods.balanceOf(blockchain.account).call();

console.log("kay:", balUser)
console.log(CONFIG.MAX_TOKENS - balUser)
        
            claimNFTsPublicSale();
        
}
else{
setFeedback("Sale is not live, check our Discord for updates!")
setSaleClosed(true)
  return;

}

}




  


const claimNFTsPresale = async function() {


    let cost = CONFIG.WEI_COST_PRESALE;
    let totalCostWei = String(cost * mintAmount);


console.log(blockchain.account)
console.log(mintAmount)
console.log(cost)


const { MerkleTree } = require('merkletreejs');
const keccak256 = require('keccak256');



let whitelistAddresses = ['0x5235aD5d8681CC509113dA43F56504e4525a8218', '0x32216985248b179e68B40ffAa93919E7E7Dd0ebe', '0x55c254fe3eC4e8a5d4AA51044359fa0571cDa0db', '0x426806F5db31333C5f1ef4548A7D91c5C9934015', '0xf1b1B554972b74BD0f545e054803175cb465b733', '0x9Bd59990bf4deECb38cE7a6fB4860B1396E1b03a', '0xAB27137F278BDBf7Df03a41D0233926D1147dae3', '0x83680F048985b2E645f22E4Deab494B766c44Dde', '0xbF79382B9fE48610ffdB09596F529067baA5e9f3', '0x3827fa3B18fA36f9F40f146455B85A141E05b066', '0x1a010A7001cca2d86E390b1cb08b74FBC5969d11', '0x589Bf209F07772BEcF9a1D6f9A50A135E770993b', '0x7409E77a2aef2fe824Fe81cF55D441E5d0Df6749', '0x16630f9b1Cd978a505421b1D77Cda2d141112B59', '0xfa1be3Bf3C22871bb05B5448470a5860fA95Ba4e', '0x28A97280875b16ea73a4e21f3e119Bcd77fA0E9a', '0x8a2187a2F943ead3D9e74f4fe9BD2a477De97e89', '0x1C10581326432cB10D4E37C14E18Cd4EF41F7C6d', '0x38d83039be421978Ef026E517c11E1E13Dd10BC1', '0x30B5720C467020B2d09aB50ce051C6095B1bc112', '0x6769d964f1362CeBEc1DfE0254171Fbc421B25C6', '0x488d4524Db91a2A24576d53706Ef5B0ed1644751', '0xed45758844611d574c0cd0264845f353ca2788d4', '0x5a33ca768Baa7BCfA9ae55e690D28ff5f171787b', '0xE96C2122790b3B9568Daec91Fed2Cbc465bAa539', '0x047D6F2285C5fFEaB610c927DE6f86a2B2e9e738', '0x74aC37f2ad54f4b0fe3ABA0344381E3BFbAd9Dca', '0xB674F02761cA934E181FC5006F71f011Ee381A20', '0x0e91E4208d141587fc50CF0AC602C0aC4AD97bD6', '0x9275198560dF5215440565C6Bd0b9d2E99b6aa9C', '0xC314c8F4dAAF6F439dDa9bC972EDFc4Bbf7a1458', '0x913cF7A3DEfB54E04d2cc0E92112c20cC69f6758', '0xb8c75b79bFe3d910C48Ebe59F01c1544DAECC245', '0x2a6893c390B77E86fD60A58d89DD20436eaC75cB', '0x07d90911c1704a7fe65929155301d632FfB54FBf', '0xb12bb60594C2dE5CBAA3Ec1090317D09c156eE70', '0x0e25bF2d0eF897b604536153FaC2fD3A9AF4be50', '0xCFBc31f36E815dCB314F74e920c6d25C8D8194c7', '0x61308784d90a474DAeeD357a40a6301BabAA0376', '0x3Aa3074cd6EDFb2f9aA61C8A233f4A8bd53113d1', '0xB5ad5874133F7adB54CCAa56D4c6FDddBD01Fd90', '0x09bfa99beccbe7f815480219726cd8e96b8a8f76', '0xE99542D199bF085a0299890Bc0F9b873BA6082F7', '0x714844D10A89E0Ad06bbb42aC130419456b769C4', '0xc1d423aE49fba66AA713610811d13e0BECf213c6', '0x923e3491eE0E3b19eDC783Eeb76C5185fED7d65b', '0x96355336955417Df5e146Cc92e70b900674E35e5', '0x61247198725819809Ff1875A586029B1154A9FCC', '0xEF3f009b2e3Ce2798c0e88827c3f8728245645bF', '0x19355F653CCCFB9cA64c658C797da59d64A6aE60', '0x359f826022F75A6B49d01Cc3d2EE6d4B7Ea3b35d', '0x78998c71a2DECeA3111cf80a08627B8Ad8163095', '0xDBDE2CEcA73d2E544B6b9687Ec4BD3b87b774CeC', '0x1a57AA9D05dCB7E0073b799BB8068B0AF1ff4030', '0xf09748b2f02812B1553CB32E818ccC1D34DE1226', '0xe5B2509D01Ab0653eCa55F3B8A141f012A2B8a40', '0xB75E81915d04527dD49c78eC27D7E063D7943573', '0x860d50d5093396E315C4468c21868f44e30a91A3', '0xd965c0be4403d0301fe15b3e0b16c7fb9e82072f', '0x1b4862F983AA573518B612f1bb1579F4b02796CB', '0x6765e29E29c6ff14628E172b8eEF53D8496680c1', '0x208C771C52ebe4b53102BAAB86d52FEaA125240D', '0x14a88E30B610Cd12A029BC8B182d80d0C5cBF130', '0xdDF6eBe8C4d4804c495A4d3A6aBBc423a123b732', '0x0c0E0966D6f6533579de8265837A5ad5baDb2E09', '0x3ceCc1C33276226c2124Ae91C5521bCD10B507bF', '0x8Ae0b7DE9E955a9F2740B2cE7133c694d6a82297', '0xd6c96534CD8b80aFc596e034088f2dbBF630B1c9', '0x85Df5Cf515f55362002a1Ea861aC2857b2D97cf2', '0x954e651DE1489876550E8dd941944Dc62A8dDB74', '0xD6bba09DeE0DdC465c22a23cb8548a524eb994c8', '0x5ccE8e6a13F7E07d1C3225Dc9449C3e8AdE31c80', '0x04a0a3Da5b104433625bBb34eFB06Ea742fca8e3', '0x7C2ebf00200118Ba749FBc4F072a47BFE338586D', '0x068f432b624D9aA2c02cB6a5Cbb72Dbd14E72f81', '0x90B693b7E536108af7F18CB124a38145c10FC900', '0x001742d9B887e6A0dc22D08D11D4bd19C7d0610b', '0x6B756219f10C50ba4CD085fcD882d79f53A90384', '0xCA3B6e983a36cb1F34B1B0BF7F937E31109Cc31C', '0x51FB92b738e291D8704177Ed87531dC428078824', '0x9Fd21D13a5f712d57803B43818e8b4F3B7dbCDDf', '0xF664E24B90795b050313Df86160646f37684502F', '0x67b88bD645bB8B477C77fe9F78e08fFbd265cD38', '0x8b4EF241f31B7dA8C248400ea00eED51ae2e8919', '0x47Ef230b82b5b861f5D935CA720Af18EE42428aA', '0xE89F8D2c4468dCe8Fbab5d0091Be44b8BAF7cd47', '0x744440D74E402c304b758E8589a6454a826CBa0e', '0x26Ac155F40A4Ac8fcac27b45D3bd38F17B928BE2', '0x1E545bbb0cC33163fED5339f7a72167B53EdA13a', '0xab48836850C30d62c74E62F9D7cDCBbbb7505E4e', '0x4C840032241569B9138Ac5acdf1828983beBc675', '0x97534Bc03E04F9e7466B65dDa2e81045a697eC0C', '0x1CFC41F1243E7F73E7a9429E5Bb36E487A69Ff2a', '0xFcfAc2df6E993E76F34FbCb0dfb24491B1572bb7', '0x45784C2c18E51d75B75d3EC799F18E8C56a524B7', '0xAA7fc8E44bE988e14f572c407d5cB5395F5c54CD', '0x72721C80A019d31d9d6135D47dabF21A0c7fc254', '0xC71d87fF29352B66Fbcc75D57F12e37E2604D94d', '0xA63D2Bd7971DeA345725Af8DFE7EE011205B144C', '0x20eE3Bed39a2C625B246265348Ebe9FCa60bE9bd', '0x6B25C993Fce59CcB9061a99901bF13237c215810', '0xDFc387D937488A300bb73eD805b1E46CDfcF28Ae', '0xD1B8726d9A4e1D7F2E7262CF19E7ED0BEA277F60', '0xf1306848C778A930B50698B046b714235b3dD441', '0xFD1dca138CB255Ec0A93da370DA70B69093b67f0', '0x5293281154ED12d31f07622F5Fe5e01E060B371C', '0x4EFA29c10092D73e616c48A968F1B18944D78153', '0x01bb40802b1Fae00F09b4F8ab0B9705650827D3b', '0x4407f7914754Bd16d383eD9E18ab25F91A274E03', '0x26A121B7244b65B767ee61e3B3e39fC06FF498aA', '0x5fD21B488987365b2C79aD42e5Ac6c15A1EA9cF0', '0xa54cd35E2E2D0DdFB03C677B981d9361743D82E2', '0xf6Bedecee1C04F1e397f633bb2b0d3f81ac4670f', '0x5b4388acbc161bC5d7Aa4263Cc07a83DC6B8f336', '0xDADa6af9D17B79d2a6e916c415178c3Fc252bD9A', '0x2F3C11d43dCe473927B5A624E7B46f07F01Cc827', '0x2e320517546FD8B36015D9e06c35abEaa1c2767B', '0x66F23A43223F4256A28a05784E638343BE21B2a0', '0x6300bbce3090fd737277365bd9d38aa650d2aac6', '0x6fbEa6CABAE1F2248B47e88bae99Df610E1373c8', '0x9d8D56a329e3D30a170c8D09B04863249942e50C', '0x6a70dBAE32970469c18B90D47716bFbDD2Df59F8', '0xB769577361A0930EB89Abc634B818ba06B55D38b', '0x9107b2cfc1b71625176B550bB84C9881272d4730', '0x59C4479D3861f2FbA2fC6D6D0B7D243cDD0E5874', '0x96dd5C29Ee2923E1c5a920107d44D829f11F79F1', '0xAB343C36795467a395C9703D13c19B2c371691dc', '0x10fb208c95a8EDd74fd75A65738BCb57a99C5c6c', '0xB12821D0D7e50732E114A2536F0A52AD0A9561cC', '0xf22eE293c607393756428Fd54cC3ac32d0EE5637', '0x65Af2CBc64465b7955C2d8Cc5BAdF4414423F677', '0xD2C1C84f12a6931160557CadD7D1699964dad6C4', '0x231508D8245Af019c824aa81CB1e878D2C128e59', '0x1b35F030f9024436B0a4168c500225d1c6B9703E', '0x0F212042347bd15210C66c01a3109c3157f2A12A', '0x2D0Eeb261E5Bb201723591E651173A2cc112CcB8', '0x69d7178c40474ba4FeeC8443d370be17C24e67a0', '0xBb532FDbF95Babd8Df98DB9CcB60704503E769b8', '0xA31EcDF6f79D0bbbD888E692fB930CB41C3671b8', '0xFBf25d8Da4F1CE86B9A522dFCAaE12Be93DE7F20', '0xDd70f746e6CdF8df1D32668B19f099f82943d713', '0x96962183Ce78952A4cA325c16B4a5847144d6b46', '0xF40Bc9de6D17999b6be0BEb89C72e5dB85E60528', '0x8d4d90e1dde050178164466931fe48b57d82896e', '0xdD1a89c112E792B9678119AB25F1bd97235aD3ac', '0x8Dc7ad48E7F0eEA5bD0418264D9d0983d5B162EF', '0x7AeC7b613Ea9FCBD53d7e2F8d20EdaE3AF3d6516', '0xe41e2d47FEAC1cA9cBF1d199a14f4751d5746ded', '0x4583384e4f517068CD58F64E53a6148d9c61529B', '0x3BCF918E060E524bBb70B767Cc7105445ee47aF4', '0xD1985eFf4C014EAe4e2d3EdC7F91DE77390c8590', '0xC707CdC817EB7a9376B604C673227a4564B5B47C', '0x6e5d59fde75eb8d26a7c52e8bd4df3ccd855382c', '0xe324C2f2524c0a7288866F9D132d5b43ef038349', '0x7B6B99C4F06f2E10c76378158A44E19eA02CdFf8', '0x6E5c200A784ba062ab770E6d317637F2fC82E53d', '0x52c635F0C85F2B40F8206a5afCa7EC7091B945B9', '0x0Bc3D4a917D86fa13A7c0bF7a93a1716cE6B17A8', '0x414aE5317aC0109d3B4B78a739E46EF6594A8117', '0xCe4C3FB0aA1307554C5eDD6027aA5e617BeFFB83', '0x2241B11F2B57601721486520b430A1F5557cE166', '0x1798Df94fa63C01C5f66922F991E28F678AB995E', '0x9CaF118A8d7651327d6Fb36F9858E8f4fef944CA', '0x52691F4dc64C6aF007Ff4188eAa644D6cdC3514c', '0xD6a02bbcc789BEcA35b72bdf1092AF64ce019193', '0xd75Adb8f0B332e62bc3ac47db2B934b88E4a1b85', '0xBA78CD28F7132958235D278fF3C5DC5E6d34cc15', '0x41D1C1bBDD8ce06ac70b418F1d0c26e33e13b31F', '0xB48393dfC231C96AbD4d3e46774DCcF79f51f240', '0x32f3f4f0c60b138db0B8028ab3d355FEF4793E2A', '0x143Ee623AE0D665A4D3711c3Ae54741a962F9ec5', '0x37d93F0Dee6bE3e8bDDC4D0Cb03A70e8ECC8b1fC', '0x7c6d25E56Bb79Ad8aC787182Be9479039F03552e', '0xcb94186DbbA747E0f60771adf77c5BD641a22303', '0xcf7cdb1b29cb9db0c45d8270b6292e701c3f4e32', '0x18D8dde594dE9D42325055C75fA548611030A366', '0x20Cd114EcF70C79502Cc2b47b7d70C3a5F6b508e', '0xe183715c18072d9c64a8081d0d6c0762465bdf72', '0x90f3490B7AbCe5956EbB4B0A375e5A5F17E7Df5e', '0x347F76a9864689B4AaE7fD405ECf817F0Ecc74c6', '0x7545b33E2B61f5bA9ec3b13141D78434D8960804', '0x9Fae3C44932a0FFb29AF4df736cDF028637bAe90', '0x38CEC25C71266d65a65EC693B81EbE557E014c75', '0x2d5ef319eaD71190b49Ac4E0e3ec1281e4D59E9E', '0xB8F3AC467A137c4dA77F7841084825C122993746', '0xD038a4185bcb19e828DEf749087b6342aFD14220', '0xdAa33Ab502a6AC84360be6DDb60B380A022E2167', '0xC63A75fF293170C0726C5367871160135036389d', '0x0C4938ec23887D1384dA8c0E611042905a366f0E', '0xc76beA954a1e91c7EED4aE7ee20Ee3844ee93472', '0x07aabC0969d650009e2f30F04492D867D45045c0', '0xe4133F2A6Cf470375Aedc187C5d7E22eEA490aa7', '0x3fF51728Fae79B1b9Cb959475e09b159CD75a91C', '0x4fa5bad11d57eaa321ca2fd0796d9b58d9841dad', '0xe4205a1fd0802764285aEa427DdbaAfB91f86cb5', '0x4c4d8164471f6852E5409f8f25559C264E22D6D6', '0x70897aacA806Fbf121bff01Ec4485707Fa98F6aD', '0xe923794DB7C68A147FD0e301e992E2830F90f302', '0xC610430E4139f1a384D61713f1DDF7a8Dd9Da4f4', '0xFe73427C3C4ae4d984964a755E88cEB55D8C7e45', '0x68bF7C0695E474af070CE875f7b997cd210701c9', '0x090DEb24A178AD520f4C7575906f55d6Ed4597Bc', '0x43A53dC2aD5880B3026F9FdB5A52a1F47c6F2b32', '0xF06beD3f0DAd7932d8D00fe48C36751f5C10be23', '0xe1B0F2A5B367bC821fBA79AF4EbD063C8210ee1c', '0xBbFB0F147a22b3e9A4B81c276596Cb4675c4351F', '0x52a06BF3Eb14b3a66a6354ed6e8f291EB922DF98', '0x2E87AFA8c61A0C3F67e5367aaa5Eb1b18bE2d3Ab', '0x393Bd756A5f8e515D791d8F3C9C248Bbf3Ea84e2', '0x6ec9b720ed2A3b825a96b5BFA11C3f9e8a93a458', '0x9fd7910B8Ca22EF3a6820A8136648e64Ae5b16b3', '0x4f06a57E93D591708CA05103b5a0707AC8FaeEAc', '0x8e68112d0ffb924475f3c8bcea9a057929b5b58f', '0x99a78c09425ee949e1892f11d74b65d0a28a5ec6', '0xCba121F9dE69572989d567d9623b8465aA83Fa16', '0xA9Db22dB02d2481A42707555cc59AFA018384b41', '0x057986BF560d43c460ee4f8d86514DC32414632d', '0x85146c9AF6593ebcb78CbA7B3e0E7b88565973EF', '0xa81476CEF31940Dd0236be6A486b9230EcE49743', '0x73a97722A0Af29b1Ed4c2507dFb2e7f567BA3250', '0x6Ec14233d03De158179F4c2d0b18bfb8105B41FD', '0x5E62049745551C81C3CE8f7EC82B7F9ACfeA8b70', '0x6B663d3218a5A3cEbef5ff3f9a930e90039bbD24', '0x7eCd91540Fb69d2A008e13DF316972e3606b826F', '0xc64202e2B512c72c3e145776A7B556457075Fe9F', '0xF7de85Ec11cC21AF1cE76F4A711e4d749F2a6a0F', '0xF21E12AB125D919F821098510C18FA896770E708', '0x5479B817E0C5969b661eF32e8398F499Af222304', '0xF55406D78dD136374C249C5A15c5442b1B384A4b', '0x5AE2B03cF9516cfd6aD09bbb6DfE44ABAe71534a', '0xa692C74D5b22A0DF6dd7728576590AdB6947F884', '0x17F620C8CB73832A42bb4e45440807AF94CE5481', '0xD3d84D5FbD8C7225352B630E52cfB76869773B09', '0xc8288E5CB28686bc1c730D008b704fEa5Ad76E2D', '0x0720E644d5144149Fabc524d656B0CE78443F77B', '0xd507bF1fe1de2fa077a7cb08df7e6ee195cC6293', '0x33bD2A5629Ca87ae9ba49CF5352A8Ff29C05A836', '0xb52C03C2ece04f4D26DE0f8629E6F81BF5FAc02e', '0x945FF5d700230eC32d1a0676C0Bb7f3598f0728c', '0x2f153d15c86db8893e69ee55ce8723994cfcc8ea', '0x6292c8e642e25DD8A17D15D78149EA1C7D2A0214', '0xb9707B1E71850DC690F002229dbB931591A07489', '0xcbc98D5cf555c1cB61ad8de92459ba0ae7b50673', '0x6FE025Dc79FEF8114e19D3370903E3166A625bB9', '0xdEcDD028bE07eF35B95367Ab92543287B4133537', '0x54b4fbfbd87f6f78b83aadb6f14fce86b4708bf3', '0xE105258de1974B68287280fc6f762D7f369bC674', '0x16D3916ddB48E5c68d756580bCF7D6d76815bb16', '0x47D0DD1c5A0125F6e52fBAc3e202bfec60eCBDc2', '0xd926c21B5ae693BA1376EBB67877097909DDEd92', '0x04394f6EaB27d021D73321818B821a00d843b63E', '0x18B1146573cEbdF82D8Ce7D7698D172499C95755', '0xB430dd3fd215C0E34Ad70d35a3feee6fB6a0396c', '0x32E3Dc8878a2cD82Cfcfc0aF20Cdb73Fde6bE798', '0x08016FfE846fB27f240D5542a80E8639bE725405', '0x77f82685c4901a1C8A59013E9d37699C097c97f1', '0x5bF91fD1944E5BdEF6c5261f806e615AFdCbF07F', '0x33e67B86aFc61b56F3876C2aa4766E0bC967Da79', '0xC97d2Cb7645B473e026E1FCc8eC93E5061e6eBD2', '0x180482fa9e1CB4f505270Ee0E399744C6B6E727E', '0x2B2A80f6Ea4E62fE85C125FbA213a8994b441E6A', '0x84cD584Ac9AA22D1254036Dc91e8f1608CEBc83c', '0xA5F9D88E5D05CFD771B6f2908C41a651850Dd091', '0x30E8eDBcb3148Bb4A659E0C6EbADb092A6Eb496C', '0xddCAb6730Ed699188d9F7228F6ddE478FB88e1FC', '0x4b0dE0fFAE49E3bE28416328042D4036Ce2bEAe6', '0xA899Be66d7Cc0e6C05147d44Baf10b27cC7E4b37', '0xed1dbb4d6B732804aA99290d2eB36f5F6571Dc64', '0x9496a6E40d86B82434CD30Fd8c526681d26A8C04', '0x7E190dA56AE267DB583dA51C2453e06861b3F1E6', '0x8f849D23e3a82A523867a3468a91F655b163c9b3', '0x000000c58a7476F60B6A0e040CF5a3B11439885f', '0x4aECa7A5C3F644114f2a331F57D9e8d0a326e8A9', '0x96741F1Ff5da41191707A023433B763780F8260A', '0xFC3776FD3c6c2eC89824Da96529D436826D860FC', '0xFfb08AaeB1537547897B76daA2c15B36b15CD5De', '0xC0488dE21d935a10D11924E5B4fAF56c5C89Da19', '0x5a3d2bA5438d783BCD2e0d9DD7AEC60D5dfc6283', '0x0cA40CD5c9b3a0FDC62616579e35e9c0eC3d1443', '0x1b791fe96FBa6bDA4808ce7147A433d71efF815f', '0x0A670FcCdAc08AD4Af50fdD60Fc6dCB12468aAD2', '0x8b945c1312943B50C4d421520F62DaAa65Ec9372', '0xc2739a8050eA95E9F427B1E2b5B61bf44d357bD5', '0xffEE630169F32a7e5Fd16cD30F5E9adCe9971752', '0xd6Bf98ad0E9D73d2BE3Ee4BA54091B2dbC081F07', '0x466caCf7E32FE931f02b6A87A44aE8EacEEA8aF8']

const lower = whitelistAddresses.map(element => {
  return element.toLowerCase();
});

var WLconfirm = lower.includes(blockchain.account)
console.log(WLconfirm)
if(WLconfirm == true){


const leafNodes = whitelistAddresses.map(addr => keccak256(addr));
const merkleTree = new MerkleTree(leafNodes, keccak256, {sortPairs: true});
const rootHash = merkleTree.getRoot();
console.log('Whitelist Merkle Tree\n', merkleTree.toString());



var userAddrIndex = lower.indexOf(blockchain.account);



const claimingAddress = leafNodes[userAddrIndex];
const hexProof = merkleTree.getHexProof(claimingAddress);
console.log("HEYPROOF", hexProof)
console.log(merkleTree.getRoot().toString('hex'))

try{
const txData = blockchain.smartContract.methods.mintPresale(mintAmount, hexProof);
const estimatedGas = await blockchain.smartContract.methods.mintPresale(mintAmount, hexProof).estimateGas({from: blockchain.account, to: CONFIG.CONTRACT_ADDRESS, value: totalCostWei, data: txData});



    let gasLimit = Math.ceil(estimatedGas * 1.2);
    
    let totalGasLimit = gasLimit;
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mintPresale(mintAmount, hexProof)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);

        setFeedback("Sorry, something went wrong please try again later.");
          setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Enjoy your ${CONFIG.NFT_NAME}!.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });





}
catch (e) {
	console.log(e)
   console.log("Well that worked")

   setFeedback(<font color="red" size="+1">Insufficient funds in your Metamask Account!</font>)



   return;
}




}
else{

setFeedback(<font color="red" size="+1">You are not whitelisted, but Public Sale is starting soon!</font>)
return;
}



  };



const claimNFTsPublicSale = async function() {


    let cost = CONFIG.WEI_COST;
    let totalCostWei = String(cost * mintAmount);


console.log(blockchain.account)
console.log(mintAmount)
console.log(cost)



try{
const txData = blockchain.smartContract.methods.mint(mintAmount);
const estimatedGas = await blockchain.smartContract.methods.mint(mintAmount).estimateGas({from: blockchain.account, to: CONFIG.CONTRACT_ADDRESS, value: totalCostWei, data: txData});
console.log(estimatedGas)



    let gasLimit = Math.ceil(estimatedGas * 1.2);
    
    let totalGasLimit = gasLimit;
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);

        setFeedback("Sorry, something went wrong please try again later.");
          setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt.blockHash);
        setFeedback(
          `Enjoy your ${CONFIG.NFT_NAME}!.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });

}
catch (e) {
	console.log(e)
   console.log("Well that worked")
   setFeedback(<font color="red" size="+1">Insufficient funds in your Metamask Account!</font>)
	setClaimingNft(false)


   return;
}



  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {

    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 7 && data.presaleStarted) {
      newMintAmount = 7;
    }
    else if (newMintAmount > 20 && data.publicSaleStarted) {
      newMintAmount = 20;
    }
    else if(newMintAmount > 20){
	newMintAmount = 20;

    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };




  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (


    <s.Screen>
      <s.Container


        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
      >

<StyledLogo alt={"logo"} src={"/config/images/logo.png"} />
        
        <s.SpacerSmall />
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            
          </s.Container>
          <s.SpacerLarge />

          <s.Container


            flex={0.4}
            jc={"center"}
            ai={"center"}


            style={{
              
              backgroundColor: "#FFBEBE",
              padding: 14,
              borderRadius: 14,
              border: "",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",

            }}

          >
<StyledImg
              alt={"example"}
              src={"/config/images/example.gif"}
              style={{ transform: "scaleX(1)" }}

            />
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 30,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}


            > _______________________ 
            
            </s.TextTitle>
<s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 30,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}


            > Join the Cloodleverse! 

            </s.TextTitle>
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 27,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}


            >

                          {data.totalSupply} / {CONFIG.MAX_SUPPLY} 
            </s.TextTitle>
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary-text)",
              }}




            >
              <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK}>
                {truncate(CONFIG.CONTRACT_ADDRESS, 64)}
              </StyledLink>
            </s.TextDescription>
            <s.SpacerSmall />
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>

                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>


                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  
                   <font size="+2">1 {CONFIG.SYMBOL} costs 0.079{" "}
                  {CONFIG.NETWORK.SYMBOL}.</font>
                </s.TextTitle>
                <s.SpacerXSmall />
        
                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      Connect to the {CONFIG.NETWORK.NAME} network
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                        
                      }}
                    >
                      <font size="+2">CONNECT WALLET</font>
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{

                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{ lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                      >
                        -
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                          fontSize: 27,
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <StyledRoundButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                      >
                        +
                      </StyledRoundButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                     


                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();

                          presaleMintBtnClick();

                          getData();
                        }}
                      >
                     <font size="+2">{saleClosed ? "Sale Closed!" : claimingNft ? "Claiming..." : "Mint Cloodles!"}</font>


                      </StyledButton>



                    </s.Container>
                  </>
                )}
              </>
            )}
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"center"} ai={"center"}>
            
          </s.Container>
        </ResponsiveWrapper>
        <s.SpacerMedium />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          
        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
